import { useState } from "react";
import { CreateShipmentDetails } from "./CreateShipmentDetails";
import { CreateShipmentItems } from "./CreateShipmentItems";
import { PurchaseOrderItem } from "@domain/purchasing";
import { useShipments } from "@features/shipments/hooks/useShipments";
import { Shipment } from "@domain/shipment";

interface CreateShipmentFlowProps {
    onClose: () => void;
}

export const CreateShipmentFlow: React.FC<CreateShipmentFlowProps> = ({ onClose }) => {

    const [purchaseOrderItems, setPurchaseOrderItems] = useState<PurchaseOrderItem[]>([]);
    const [currentStep, setCurrentStep] = useState<'purchase-order-items' | 'shipment-details'>('purchase-order-items');

    const { createShipment, addPurchaseOrderItemsToShipment } = useShipments();

    const handlePurcahseOrderItemsSelected = (purchaseOrderItems: PurchaseOrderItem[]) => {
        setPurchaseOrderItems(purchaseOrderItems);
        setCurrentStep('shipment-details');
    };

    const handleFinish = async (shipment?: Shipment) => {
        if (shipment) {
            const newShipment = await createShipment({
                name: shipment.name || '',
                transportMethod: shipment.transportMethod,
                departureDate: shipment.departureDate,
                arrivalDate: shipment.arrivalDate,
                destinationWarehouseId: shipment.destinationWarehouse?.id || '',
                processedDate: shipment.processedDate,
                purchaseOrderItemIds: shipment.purchaseOrderItems.map(item => item.id || ''),
            });

            if (newShipment.id) {
                await addPurchaseOrderItemsToShipment({ id: newShipment.id, request: { purchaseOrderItemIds: purchaseOrderItems.map(item => item.id || '') } });
            }
        }
        onClose();
    };

    return (
        <>
            {currentStep === 'purchase-order-items' && <CreateShipmentItems onNext={handlePurcahseOrderItemsSelected} onClose={onClose} purchaseOrderItems={purchaseOrderItems} />}
            {currentStep === 'shipment-details' && <CreateShipmentDetails onBack={() => setCurrentStep('purchase-order-items')} onFinish={handleFinish} purchaseOrderItems={purchaseOrderItems} />}
        </>

    );
};      